const KEY = 'returnUrl';

// Normaliza un hash de HashRouter a un path interno; devuelve null si no es
// una ruta interna válida (anti open-redirect).
const normalizar = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  const path = raw.startsWith('#') ? raw.slice(1) : raw;
  // Solo rutas internas que valga la pena restaurar. Ampliar el prefijo si se
  // habilitan deep-links de otros userTypes.
  if (path.startsWith('/specialist/')) return path;
  return null;
};

export const saveReturnUrl = (raw) => {
  const path = normalizar(raw);
  if (path) window.sessionStorage.setItem(KEY, path);
};

export const consumeReturnUrl = () => {
  const path = normalizar(window.sessionStorage.getItem(KEY));
  window.sessionStorage.removeItem(KEY);
  return path;
};
